const Customers = () => import('./Customers'),
    Customer = () => import('./Customer'),
    CustomerRoot = () => import('./CustomerRoot'),
    Invoices = () => import('../invoices/Invoices');

export default [{
    name: 'customers',
    path: '/admin/customers/:page',
    component: Customers,
    props: true,
}, {
    name: 'customer',
    path: '/admin/customer/:id',
    component: CustomerRoot,
    props: true,
    children: [{
        name: 'customer-details',
        path: 'details',
        component: Customer,
        props: true,
    }, {
        name: 'customer-invoices',
        path: 'invoices/:page',
        component: Invoices,
        props: true,
    }],
}];
